import { GeneralStyle } from '@website-builder/model/style/general-style';

export class PanelStyle extends GeneralStyle {
  backgroundColor: string;
  useGlobalStyles = false;

  static normalize(styles: Partial<PanelStyle>): PanelStyle {
    const generalStyles: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new PanelStyle();

    Object.assign(pureStyles, generalStyles);

    pureStyles.backgroundColor = styles.backgroundColor ?? pureStyles.backgroundColor;
    pureStyles.useGlobalStyles = styles.useGlobalStyles ?? pureStyles.useGlobalStyles;

    return pureStyles;
  }
}
